"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecoverIn = void 0;
class RecoverIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return RecoverIn.attributeTypeMap;
    }
}
exports.RecoverIn = RecoverIn;
RecoverIn.discriminator = undefined;
RecoverIn.attributeTypeMap = [
    {
        "name": "since",
        "baseName": "since",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "until",
        "baseName": "until",
        "type": "Date",
        "format": "date-time"
    }
];
//# sourceMappingURL=RecoverIn.js.map